var _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerpoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "512px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 24.33 32.53",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.23 0h10.88l9.22 9.61v18.69c0 2.33-1.9 4.23-4.23 4.23h-15.87c-2.34 0-4.23-1.9-4.23-4.23v-24.07c0-2.34 1.89-4.23 4.23-4.23z",
    fill: "#E03303"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15.1 0 15.1 9.53 24.33 9.53",
    fill: "#fff",
    fillOpacity: 0.30196
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.76 16.13c-2.44 0.12-4.38 2.15-4.35 4.62 0.04 2.46 2.04 4.47 4.5 4.5 2.48 0.04 4.51-1.9 4.62-4.34 0.01-0.12-0.09-0.22-0.21-0.22h-4.13c-0.12 0-0.22-0.1-0.22-0.21v-4.14c0-0.12-0.09-0.21-0.21-0.21zm1.1-0.67v4.13c0 0.12 0.09 0.21 0.21 0.21h4.14c0.12 0 0.21-0.1 0.21-0.22-0.11-2.34-1.99-4.22-4.34-4.33-0.12-0.01-0.22 0.09-0.22 0.21z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerpoint);
export default __webpack_public_path__ + "static/media/powerpoint.010e2715ad1ee5f13cec7a84c9ca2454.svg";
export { ForwardRef as ReactComponent };